import { ItemZoneContextType } from '@context/ItemZoneContext'
// import { useAppStore } from '@store'
import { AnyID, ReactMouseEvent } from '@types'

export default function handlePaste(
  ctx: ItemZoneContextType,
  e: ReactMouseEvent,
  zoneName: string,
  editZone: ProjectActions['editZone'],
) {
  if (e && e.preventDefault) {
    e.preventDefault()
    e.stopPropagation()
  }

  if (!ctx.copiedTexture || !ctx.object.current) return

  const id = ctx.object.current.id as AnyID
  const pasteIcons = ctx.pasteIcons

  if (pasteIcons[zoneName] !== 'canPaste') return
  editZone(id, zoneName, ctx.object.current.zones[ctx.copiedTexture.zoneName].material)

  const newPasteIcons = { ...pasteIcons }
  let pasted = 0
  const pasteArr = Object.keys(newPasteIcons)
  pasteArr.forEach((key) => {
    newPasteIcons[key] = key === zoneName ? 'cantPaste' : newPasteIcons[key]
    if (newPasteIcons[key] === 'cantPaste') pasted += 1
  })

  ctx.setPasteIcons(newPasteIcons)
  const allPasted = pasted === pasteArr.length
  if (allPasted) {
    ctx.setCopiedIconId(null)
    ctx.setCopiedTexture(null)
  }
}
